import { useEffect, useState } from "react";
import useUser from "../helpers/useUser"
import apiClient from "../utils/apiClient";
import { Link,useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function PageHeader({subTitleColored=false,pageTitle,userCallback,isColored=false,subTitleSize='normal',subTitleBold=false,blueTitle=false,cart=false,cartContent=[]}) {
    const {t, i18n} = useTranslation();
    const navigate = useNavigate();
    const [user,setUser] = useUser();
    const [userData, setUserData] = useState(user);
    const [userMenu, setUserMenu] = useState(false);

    const userId = user ? user?._id : null;

    const getUserData = async () => {
        try {
          const response = await apiClient.get(`vendors/${userId}`);
          if(response?.data) {
            setUserData(response?.data);
            if(userCallback) userCallback(response.data);
          }
        } catch(err) {}
      }

    useEffect(()=>{
        if(user) {
            getUserData();
        }
    },[])

    const handleClickSettings = () => {
        navigate(`/${i18n?.language || 'ar'}/settings`);
    }

    const handleClickProfile = () => {
        navigate(`/${i18n?.language || 'ar'}/profile`);
    }

    const handleClickTerms = () => {
        navigate(`/${i18n?.language || 'ar'}/terms-and-conditions`);
    }
    
    const handleClickLogout = () => {
        window.localStorage.removeItem('token');
        window.localStorage.removeItem('b-user');
        if(typeof window !== "undefined") {
            const pathLang = window.location.pathname.split('/')[1] || 'ar';
            window.location.href = `/${pathLang}/login`;
        }
    }
    
    const handleClickCart = () => {
        navigate(`/${i18n?.language || 'ar'}/marketplace/cart`);
    }
    

    return (
        (userData && userData !== undefined) ? 
        <header className={`flex flex-wrap h-auto lg:h-[96px] relative ${isColored ? '!bg-white' : '!bg-white'}`}>
          {/* Title section */}
          <div className="w-[60%] lg:w-[50%] pt-[5px] lg:pt-[25px] ps-[15px] lg:ps-[25px] relative">
            <h2 className={`text-[18px] lg:text-[24px] ${blueTitle ? 'text-blue' : 'text-grey-900'} font-[700] mb-[5px] ${pageTitle?.subTitle ? 'leading-[28px] lg:leading-[36px]' : 'leading-[40px] lg:leading-[56px]'}`}>{pageTitle && pageTitle?.title}</h2>
            {pageTitle?.subTitle && <p className={`${subTitleSize === 'normal' && 'text-[11px] lg:text-[13px] leading-[18px] lg:leading-[20px]'} ${subTitleSize === 'big' && 'text-[18px] lg:text-[24px] leading-[22px] lg:leading-[27px]'} ${subTitleBold ? 'font-[700]' : ''} text-grey-950 font-[500] whitespace-nowrap truncate overflow-hidden ${subTitleColored ? '!text-darkBlue' : ''}`} dangerouslySetInnerHTML={{__html: pageTitle?.subTitle}}></p>}
          </div>

          {/* Actions section */}
          <div className="w-[40%] lg:w-[50%] text-end pt-[5px] lg:pt-[20px] pb-[5px] lg:bp-0 pe-[12px] lg:pe-[25px]">
            {/* Wallet info - hidden on small screens, shown on lg */}
            <div className="hidden lg:inline-block align-middle cursor-pointer border-[1px] border-grey-100 rounded-[8px] h-[56px] pt-[5px] me-[15px] bg-white">
                <span className="inline-block align-middle w-[50px] h-[32px] !bg-center !bg-no-repeat border-e-[1px] border-grey-100" style={{background:"url('/assets/images/header-wallet.svg')"}}></span>
                <Link to={`/${i18n?.language || 'ar'}/wallet`} className="inline-block align-middle relative px-[15px] select-none border-e-[1px] border-grey-100">
                    <p className="text-[12px] font-[500] leading-[18px] text-grey-600 mb-[3px]">{t('header.walletBalance')}</p>
                    <p className="text-[18px] font-[600] leading-[18px] text-grey-900 lang-font" dir="ltr">
                        <span className="w-[11px] h-[11px] me-[5px] inline-block ltr:hidden" style={{background: "url('/assets/images/header-sar.svg')"}}></span>
                        {userData?.credits?.toFixed(2) || '0.00'}
                        <span className="w-[11px] h-[11px] ms-[5px] inline-block rtl:hidden" style={{background: "url('/assets/images/header-sar.svg')"}}></span>

                    </p>
                </Link>
                <Link to={`/${i18n?.language || 'ar'}/wallet`} className="inline-block align-middle relative px-[15px] select-none">
                    <p className="text-[12px] font-[500] leading-[18px] text-grey-600 mb-[3px]">{t('header.incomeBalance')}</p>
                    <p className="text-[18px] font-[600] leading-[18px] text-grey-900 lang-font" dir="ltr">
                        <span className="w-[11px] h-[11px] me-[5px] inline-block ltr:hidden" style={{background: "url('/assets/images/header-sar.svg')"}}></span>
                        {userData?.income?.toFixed(2) || '0.00'}
                        <span className="w-[11px] h-[11px] ms-[5px] inline-block rtl:hidden" style={{background: "url('/assets/images/header-sar.svg')"}}></span>

                    </p>
                </Link>
            </div>

            {/* User menu button */}
            <div className="align-middle cursor-pointer inline-block border-[1px] border-grey-100 rounded-[8px] h-[36px] lg:h-[56px] pt-[2px] lg:pt-[3px] relative bg-white select-none whitespace-nowrap" onClick={()=>setUserMenu(!userMenu)}>
                <span className="inline-block align-middle w-[30px] lg:w-[60px] h-[30px] lg:h-[48px] !bg-top !bg-no-repeat rounded-full overflow-hidden" style={{background:userData.avatar ? "url('"+userData?.avatar+"')" : "url('/assets/images/profile.svg')"}}></span>
                <div className="inline-block align-middle relative pe-[20px] lg:pe-[40px]">
                    <p className="text-[12px] lg:text-[18px] font-[500] leading-[27px] text-grey-900 mb-[0px] truncate max-w-[100px] md:max-w-[100%]">{userData?.name}</p>
                    <p className="text-[14px] font-[500] leading-[18px] text-grey-600" dir="ltr"></p>
                </div>
                <span className="block absolute top-[6px] lg:top-[16px] end-0 lg:end-[5px] w-[20px] lg:w-[32px] h-[32px]" style={{background:"url('/assets/images/arrow-down.svg')"}}></span>
            </div> 

            {userMenu && <div className="absolute top-[40px] lg:top-[87px] end-[12px] lg:end-[25px] w-[180px] lg:w-[200px] ltr:w-[210px] ltr:lg:w-[230px] h-auto rounded-b-[8px] bg-white border shadow-[0_0_5px_0_rgba(0,0,0,5%)] border-menuBorder z-[3]">
                <ul className="text-[14px] lg:text-[16px] font-[500] text-start py-[8px] px-[12px]">
                    <li className="text-grey-600 cursor-pointer border-b border-b-grey-200 leading-[44px] lg:leading-[50px] px-[12px]" onClick={handleClickProfile}>{t('header.profile')}</li>
                    <li className="text-grey-600 cursor-pointer border-b border-b-grey-200 leading-[44px] lg:leading-[50px] px-[12px]" onClick={handleClickSettings}>{t('header.packageSettings')}</li>
                    <li className="text-grey-600 cursor-pointer border-b border-b-grey-200 leading-[44px] lg:leading-[50px] px-[12px]" onClick={handleClickTerms}>{t('header.termsAndConditions')}</li>
                    <li className="text-danger cursor-pointer leading-[44px] lg:leading-[48px] px-[12px]" onClick={handleClickLogout}>{t('header.logout')}</li>
                </ul>
            </div>}
          </div>
        </header>
        : <header></header>
    )

}
